import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { propArrayStr, propBool, propChildren, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../helpers/recompose';
import Image from '../../../Common/Image';
import CustomSlider from '../../../Slider';
import FullScreenModalHoc from '../FullScreenModalHoc';
import FullScreenModalLeft from './FullScreenModalLeft';
const FullScreenImageViewerModal = (props) => {
    const { bodyClassName, images: rawImages, isShowDriver, onChangeSlideImage, rightClassName, rightComponent, } = props;
    useEffect(() => {
        const classList = ['is_full_screen_modal_mode', bodyClassName].filter((v) => v);
        document.body.classList.add(...classList);
        return () => {
            document.body.classList.remove(...classList);
        };
    }, [bodyClassName]);
    const images = useMemo(() => rawImages.map((value, index) => ({
        id: index,
        value,
    })), [rawImages]);
    const sliderRef = useRef();
    const setSliderRef = useCallback((slide) => {
        sliderRef.current = slide;
    }, [sliderRef]);
    const [imageIndex, changeImageIndex] = useState(0);
    const onClickImage = useCallback((index) => {
        sliderRef.current.slickGoTo(index);
    }, [sliderRef]);
    const config = useMemo(() => ({
        accessibility: false,
        afterChange: changeImageIndex,
        arrows: true,
        infinite: true,
        rows: 1,
        slidesToShow: 1,
        speed: 300,
    }), [changeImageIndex]);
    useEffect(() => {
        const onKeyDown = (e) => {
            if (isShowDriver) {
                return;
            }
            if (e.keyCode === 39) {
                sliderRef.current.slickNext();
            }
            if (e.keyCode === 37) {
                sliderRef.current.slickPrev();
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [sliderRef, isShowDriver]);
    const [activeColumn, changeActiveColumn] = useState('');
    useEffect(() => {
        const result = onChangeSlideImage
            ? onChangeSlideImage(imageIndex, { activeColumn, isShowDriver })
            : null;
        return () => {
            if (result) {
                result();
            }
        };
    }, [onChangeSlideImage, imageIndex, activeColumn, isShowDriver]);
    return (_jsxs(_Fragment, { children: [_jsx(FullScreenModalLeft, { changeActiveColumn: changeActiveColumn, imageIndex: imageIndex, images: images, onClickImage: onClickImage }), _jsxs("div", Object.assign({ className: 'full_screen_modal_main' }, { children: [_jsx("div", Object.assign({ className: 'full_screen_modal_main_image_box' }, { children: _jsx(CustomSlider, Object.assign({ className: 'full_screen_modal_main_image_slider', config: config, setSliderRef: setSliderRef }, { children: images.map(({ id, value }) => (_jsx("div", Object.assign({ className: 'full_screen_modal_main_image_slider_col' }, { children: _jsx(Image, { allowContextMenu: false, alt: 'full_screen_modal_main_image', isObjectFitContain: true, src: value, useImage: true }) }), id))) })) })), _jsxs("div", Object.assign({ className: 'full_screen_modal_pager' }, { children: [_jsx("span", Object.assign({ className: 'number_first' }, { children: imageIndex + 1 })), _jsx("span", { children: "/" }), _jsx("span", Object.assign({ className: 'number_last' }, { children: images.length }))] }))] })), rightComponent && (_jsx("div", Object.assign({ className: clsx('full_screen_modal_right', rightClassName, {
                    not_active: activeColumn === 'left',
                }) }, { children: rightComponent })))] }));
};
FullScreenImageViewerModal.propTypes = {
    bodyClassName: propStr(),
    images: propArrayStr().isRequired,
    isShowDriver: propBool(),
    onChangeSlideImage: propFunc(),
    rightClassName: propStr(),
    rightComponent: propChildren(),
};
FullScreenImageViewerModal.defaultProps = {
    bodyClassName: '',
    isShowDriver: false,
    onChangeSlideImage: undefined,
    rightClassName: '',
    rightComponent: undefined,
};
const enhance = compose(FullScreenModalHoc);
export default enhance(FullScreenImageViewerModal);
